module.exports = __webpack_public_path__ + "img/40_38_070_700.4844370f.jpg";